import { FileUploader } from '@emerald-works-nova/components'
import { Folder, FolderOpenOutlined } from '@mui/icons-material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { TenantEditSlice } from '../../../../../reducers'
import validator from './validator'

const MAX_SIZE = 2

const Label = () => <>Drop <strong>CSV file</strong> here to upload or{' '}</>

const Description = ({ file }) => {
  if (file) {
    return <span>All users in this file will have their NameId modified.</span>
  }
  return `Max file size ${MAX_SIZE} MB`
}

const UploadInput = ({ onAccept, onValidation = () => { } }) => {
  const tenant = useSelector(TenantEditSlice.selectors.tenant)

  const [file, setFile] = useState()

  const handleDropAccepted = file => {
    setFile(file)
    onAccept(file)
  }

  const handleValidation = async (file) => {
    const result = await validator(file)
    if (result.code) {
      return result
    } else {
      onValidation(result)
    }
  }

  return (
    <FileUploader
      label={file ? file.name : <Label />}
      maxSize={MAX_SIZE * 1024 * 1024}
      description={<Description file={file} tenant={tenant} />}
      Icon={file ? Folder : FolderOpenOutlined}
      accept='.csv'
      fileNamePrefix={`bulk-user-name-id-migration-update/${tenant.pk}/`}
      onDropAccepted={handleDropAccepted}
      articleBodyUploader
      validator={handleValidation}
      storageOpts={{ level: 'private' }}
      dataTest='nameid-migration-update-csv-file-uploader'
    />
  )
}

export default UploadInput
